import { render, staticRenderFns } from "./UninstallHelpList.vue?vue&type=template&id=3afe803e&scoped=true&"
import script from "./UninstallHelpList.vue?vue&type=script&lang=ts&"
export * from "./UninstallHelpList.vue?vue&type=script&lang=ts&"
import style0 from "./UninstallHelpList.vue?vue&type=style&index=0&id=3afe803e&lang=scss&scoped=true&"
import style1 from "./UninstallHelpList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afe803e",
  null
  
)

export default component.exports